module.exports = __webpack_public_path__ + "img/circle_check_solid.3e735b4d.svg";